import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  modalContent: {
    backgroundColor: 'white',
    borderRadius: 12,
    alignItems: 'flex-start',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  bullets: {
    paddingVertical: 5,
  },
});
